import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import { useAppSelector } from "../../Redux/app/hooks";
import { buySellAmount, formatNumber } from "../../helpers/helper";
function BondSOrderConfirmationDetail({ confirm, bid_value, principal_amount,userType, selectedPortfolios,allocate_portfolio }: any) {
  const form = useAppSelector((state) => state.orderSection.rfq_form_data);
  const totalEstMarkup = selectedPortfolios.reduce((sum: any, item: any) => sum + item.est_markup, 0);
  return (
      <div className="order-confirmation-table">
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Transaction</th>
              <th>Type</th>
              <th>Duration</th>
              <th>Price</th>
              <th>Quantity</th>
              {userType === "internal" && <th>Est. Markup</th>}
              <th>Est. Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
              <td>
                <span>{confirm.security_name}</span>
                <div className="tooltiptext">
                  <p>{confirm.security_name}</p>
                </div>
              </td>
              <td>{form.direction.toUpperCase()}</td>
              <td>{form.type.toUpperCase()}</td>
              <td>
                <span>{confirm.time.replace(/_/g, " ")}</span>
              </td>
              <td>
                <>
                  {bid_value === 0 && form.type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                    <b>N/A</b>
                  ) : (
                    <>{form.direction.toLowerCase() === "sell" && <b>{Number(confirm.price).toFixed(3)}</b>}</>
                  )}
                </>
              </td>
              <td>
                <b>{formatNumber(confirm.quantity)}</b>
              </td>
              {userType === "internal" && (
                <td>
                  <b>0</b>
                </td>
              )}
              <td>
                {bid_value === 0 && form.type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                  <b>N/A</b>
                ) : (
                  <>
                    {form.direction.toLowerCase() === "sell" && (
                      <b>
                        ({formatNumber(principal_amount)}) {confirm.currency}
                      </b>
                    )}
                  </>
                )}
              </td>
            </tr>
            {/* For client information */}
            {userType === "internal" &&
              selectedPortfolios.filter((allocates_input: any) => 
                allocates_input.client_id !== null &&
                Number(allocates_input.client_id) !== 0 && 
                allocates_input.est_markup !== 0 && 
                allocates_input.est_markup !== null &&
                allocates_input.est_markup !== undefined &&
                allocates_input.qty && 
                Number(allocates_input.qty.replace(",", "")) > 0
              ).length > 0 &&
              selectedPortfolios.map(
                (allocates_input: any, index: any) =>
                  allocates_input.client_id !== null &&
                  Number(allocates_input.client_id) !== 0 && 
                  allocates_input.est_markup !== 0 && 
                  allocates_input.est_markup !== null &&
                  allocates_input.est_markup !== undefined &&
                  allocates_input.qty && 
                  Number(allocates_input.qty.replace(",", "")) > 0 && (
                    <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row `}>
                      <td className={"td-text-indent"}>
                        {allocate_portfolio.filter((item: any) => item.id === allocates_input.client_id).map((item: any) => item.name)}
                      </td>
                      <td>{form.direction.toUpperCase()}</td>
                      <td>{form.type.toUpperCase()}</td>
                      <td>{confirm.time.replace(/_/g, " ")}</td>
                      <td>
                        {bid_value === 0 && form.type.toLowerCase() === "market" ? (
                          <b>N/A</b>
                        ) : (
                          <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(3)}</b>}</>
                        )}
                      </td>
                      <td><b>{formatNumber(confirm.quantity)}</b></td>
                      {userType === "internal" && (
                        <td>
                          <b>{allocates_input.est_markup}</b>
                        </td>
                      )}
                      <td>
                        {form.type.toLowerCase() === "market" ? (
                          <>
                            {bid_value === 0 && form.type.toLowerCase() === "market" &&  false ? (
                              <b>N/A</b>
                            ) : (
                              <b className="width-100">
                                ({formatNumber(allocates_input.inverse_currency_amt_display)}) {confirm.currency}
                              </b>
                            )}
                          </>
                        ) : (
                          <>
                            {
                              <b className="width-100">
                                ({formatNumber(allocates_input.inverse_currency_amt_display)}) {confirm.currency}
                              </b>
                            }
                          </>
                        )}
                      </td>
                    </tr>
                  )
              )}
          </tbody>
        </table>
        <>
          {bid_value === 0 && form.type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
            <></>
          ) : (
            <>
              {form.direction.toLowerCase() === "sell" && (
                <p>
                  At a price of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is estimated at{" "}
                  {formatNumber(principal_amount)} {confirm.currency}
                  {totalEstMarkup !== 0 && ` (Total Est. Markup : ${confirm.currency} ${totalEstMarkup})`}
                </p>
              )}
            </>
          )}
        </>
      </div>
  );
}

export default BondSOrderConfirmationDetail;
